import React  from "react";
declare const window: any;
export function useHubspotChat(portalId:number){
  const [ hasLoaded, setHasLoaded ] = React.useState(false);
  
  React.useEffect(() => {
     // Add event listener.
     window.hsConversationsOnReady = [() => {
      setHasLoaded(true);
    }];
   
    // Create script component.
    let script = document.createElement('script');
    script.src=`//js.hs-scripts.com/${portalId}.js`;
    script.async = true;
    script.defer= true;
    script.id="hs-script-loader"
    
    if (process.env.REACT_APP_STAGE === 'prod') {
      document.head.appendChild(script);
    }
    
    return () => {
      document.head.removeChild(script);
      window.hsConversationsOnReady = [];
    }
  // eslint-disable-next-line
  }, []);
  
  const openHandler = React.useCallback(() => {
    if (hasLoaded) {
      const status = window.HubSpotConversations.widget.status();
      
      if(status.loaded){
        window.HubSpotConversations.widget.open();
      }
      else {
        window.HubSpotConversations.widget.load();
      }
     
    }
  }, [hasLoaded]);
  
  const closeHandler = React.useCallback(() => {
    if (hasLoaded) {
      window.HubSpotConversations.widget.close();
    }
  }, [hasLoaded])
  
  return {
    hasLoaded, 
    openHandler,
    closeHandler
  };
}

